module.exports = __webpack_public_path__ + "media/src/images/canteen-128-0b9ac7d06713340dc6db6d8471235e75.png";